import { TKV2_ORDER_ATTACHMENT_API } from '@aloft/toolkit-shared';

import { useEffect } from 'react';

import { usePutCompSequenceAPI } from '../../hooks/api/toolkitComponents.ts';
import { useEdgeTrigger } from '../../hooks/useEdgeTrigger.ts';
import { compSequenceMutationComplete } from '../../redux/features/orderSlice.ts';
import { useAppDispatch, useAppSelector } from '../../redux/hooks.ts';
import { DEFAULT_SYNC_DRIVER_DELAY_MS } from './consts.ts';

export function useCompSequenceSyncDriver(orderID: string) {
  const dispatch = useAppDispatch();
  const { mutate: compSequenceMutate } = usePutCompSequenceAPI();
  const compSequence = useAppSelector((state) => state.order.compSequence);
  const { editRevision = 0, serverRevision = 0 } =
    useAppSelector((state) => state.order.compSequenceSync) ?? {};

  const onSuccess = () => {
    dispatch(
      compSequenceMutationComplete({
        status: 'success',
        serverRevision: editRevision,
      }),
    );
  };

  const onError = () => {
    dispatch(
      compSequenceMutationComplete({
        status: 'error',
      }),
    );
  };

  const mutate = () =>
    compSequenceMutate(
      {
        pathParams: { orderID },
        body: TKV2_ORDER_ATTACHMENT_API.COMP_SEQUENCE.PUT.REQUEST.BODY.parse({
          sequence: compSequence,
        }),
      },
      { onSuccess, onError },
    );

  const mutationTrigger = useEdgeTrigger({
    condition: editRevision > serverRevision,
    delayMs: DEFAULT_SYNC_DRIVER_DELAY_MS,
    action: mutate,
  });

  useEffect(() => {
    mutationTrigger.restartTimer();
  }, [editRevision, mutationTrigger]);
}
